import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["pinLocation"];
import { forwardRef } from 'react';
import PropTypes from 'prop-types';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Ba... Remove this comment to see the full error message
import BaseToolbar from './BaseToolbar';
import { PINNED_TOOLBAR_FONT_SIZE, PINNED_TOOLBAR_ICON_SIZE, PINNED_TOOLBAR_LINE_HEIGHT, PINNED_TOOLBAR_HEIGHT, CORNER_PLACEMENTS } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
// Give corner radius to the opposite corner of the pin location
const buttonRoundingFromPinLocation = pinLocation => {
  let firstButtonRounding;
  let lastButtonRounding;
  switch (pinLocation) {
    case 'left top':
    case 'top left':
      lastButtonRounding = 'bottom right';
      break;
    case 'left bottom':
    case 'bottom left':
      lastButtonRounding = 'top right';
      break;
    case 'right top':
    case 'top right':
      firstButtonRounding = 'bottom left';
      break;
    case 'bottom right':
    case 'right bottom':
      firstButtonRounding = 'top left';
      break;
    default:
      throw new Error(`Invalid pinLocation (${pinLocation})`);
  }
  return {
    firstButtonRounding,
    lastButtonRounding
  };
};
const PinnedToolbar = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      pinLocation
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    firstButtonRounding,
    lastButtonRounding
  } = buttonRoundingFromPinLocation(pinLocation);
  return /*#__PURE__*/_jsx(BaseToolbar, Object.assign({
    fontSize: PINNED_TOOLBAR_FONT_SIZE,
    iconSize: PINNED_TOOLBAR_ICON_SIZE,
    lineHeight: PINNED_TOOLBAR_LINE_HEIGHT,
    height: PINNED_TOOLBAR_HEIGHT,
    firstButtonRounding: firstButtonRounding,
    lastButtonRounding: lastButtonRounding,
    onlyLeftAndRightButtonBorders: true,
    dropdown: "right"
  }, otherProps, {
    forwardedRef: ref
  }));
});
PinnedToolbar.propTypes = {
  pinLocation: PropTypes.oneOf(CORNER_PLACEMENTS).isRequired
};
export default PinnedToolbar;